module.exports = __webpack_public_path__ + "static/img/1023_big.68c9cca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1023_big.png
// module id = x9eY
// module chunks = 1